import workspaceProjectStorage from './workspace';
import storage from './storage';
import database from './database';
import jupyter from './jupyter';
import workflow from './workflow';
// Sprint A (2026-05-21): API Gateway tenant-level (legacy) đã xóa.
// Project-scoped API Gateway: vào Workspace → Dự án → tab API Gateway.
import modelServing from './model-serving';
import lambdaFunctions from './lambda-functions';
import admin from './admin';

// ==============================|| SIDEBAR MENU – Kiến trúc mới ||============================== //
// 1. Dự án & Workspace: cửa vào theo project → Files, Big Data/Lakehouse, CV, Airflow, API Gateway, Jupyter
// 2. Jupyter Lab, Kho lưu trữ, Cơ sở dữ liệu, Luồng công việc, Phục vụ Model, Lambda, Quản trị

const menuItems = {
    items: [
        workspaceProjectStorage,
        jupyter,
        storage,
        database,
        workflow,
        modelServing,
        lambdaFunctions,
        admin
    ]
};

export default menuItems;
